import { render, staticRenderFns } from "./EmployeeSanction.vue?vue&type=template&id=33018fd4&scoped=true"
import script from "./EmployeeSanction.vue?vue&type=script&lang=js"
export * from "./EmployeeSanction.vue?vue&type=script&lang=js"
import style0 from "./EmployeeSanction.vue?vue&type=style&index=0&id=33018fd4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33018fd4",
  null
  
)

export default component.exports